<template>
  <div class="c-image-element" v-if="item && item.image_type">
    <VHeading header="h1"
      class="c-image-element__title">
      {{ item.image_type && item.image_type.name }}
    </VHeading>
    <picture class="c-image-element__picture">
      <img class="c-image-element__img"
        :src="item.image_type && addCloudinaryUrlParams(item.image_type.file.url, 'w_1000,c_scale')"
        :alt="item.image_type && item.image_type.altText" />
    </picture>
    <span class="c-image-element__caption">
      {{ item.image_type && item.image_type.caption }}
    </span>
    <div class="c-image-element__description u-text-center u-px"
      v-md-html="item.image_type && item.image_type.description" />
  </div>
</template>

<script>
import VHeading from '@forlagshuset/v-heading'
import { addCloudinaryUrlParams } from '@/utils'

export default {
  components: {
    VHeading
  },

  data() {
    return {
      addCloudinaryUrlParams
    }
  },

  props: {
    item: Object
  }
}
</script>

<style lang="scss">
.c-image-element__img {
  max-width: 100%;
}
</style>